import type { ApiClient } from "@/api/client";
import { API_VERSION_PREFIX } from "@/api/client";

/** `GET /v1/hq/creators/overview` (backend i56). Grouped counts from real rows. */

export interface StatusCount {
  status: string;
  count: number;
}

export interface CreatorsOverview {
  applications: {
    status: string;
    application_type: string;
    count: number;
    oldest_submitted_at: string | null;
  }[];
  unassigned_open_applications: number;
  decisions_last_30d: StatusCount[];
  profiles: { status: string; tier: string | null; count: number }[];
  /** `amount` is the ledger's numeric peso value. */
  payments: { status: string; currency: string; count: number; amount: number | string }[];
  programs: StatusCount[];
  memberships: StatusCount[];
  campaigns: StatusCount[];
  invitations: StatusCount[];
  participations: StatusCount[];
  performance: StatusCount[];
  brand_deals: StatusCount[];
  freelance_services: { service: string; count: number }[];
}

export function createCreatorsOverviewApi(client: ApiClient) {
  return {
    getOverview() {
      return client.get<{ overview: CreatorsOverview }>(
        `${API_VERSION_PREFIX}/hq/creators/overview`,
      );
    },
  };
}

/** numeric pesos -> integer centavos, for display through formatMinor. */
export function pesosToMinor(value: number | string): number {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}
